export default __webpack_public_path__ + "static/media/phone1.919d5b56.png";